/* eslint-disable */

/** unique or primary key constraints on table "argo.work_order_activity" */
export enum ArgoWorkOrderActivityConstraint {
  /** unique or primary key constraint on columns "work_order_activity_id" */
  WorkOrderActivityPkey = 'work_order_activity_pkey'
}

/** select columns of table "argo.work_order_activity" */
export enum ArgoWorkOrderActivitySelectColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  WorkOrderId = 'work_order_id'
}

/** update columns of table "argo.work_order_activity" */
export enum ArgoWorkOrderActivityUpdateColumn {
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  MaterialId = 'material_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  WorkOrderId = 'work_order_id'
}

